var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackward01SolidRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89529 6.89163L7.80597 6.94905C6.48938 7.79545 5.44302 8.46812 4.6995 9.08358C3.94314 9.70968 3.38505 10.3669 3.20592 11.2201C3.09803 11.734 3.09803 12.2659 3.20592 12.7798C3.38505 13.6331 3.94314 14.2903 4.6995 14.9164C5.44302 15.5318 6.48936 16.2045 7.80594 17.0509L7.89527 17.1083C9.32885 18.03 10.4642 18.7599 11.3906 19.2074C12.3227 19.6578 13.2088 19.9077 14.0838 19.6401C14.5999 19.4823 15.0725 19.2056 15.4673 18.8332C16.1281 18.21 16.3844 17.3146 16.5049 16.2569C16.625 15.2028 16.625 13.8137 16.625 12.0508V11.9491C16.625 10.1863 16.625 8.7972 16.5049 7.74301C16.3844 6.68537 16.1281 5.78999 15.4673 5.16674C15.0725 4.79432 14.5999 4.51764 14.0838 4.35983C13.2088 4.09227 12.3227 4.34218 11.3906 4.79253C10.4642 5.24009 9.32886 5.96999 7.89529 6.89163Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.875 4C20.4273 4 20.875 4.44772 20.875 5V19C20.875 19.5523 20.4273 20 19.875 20C19.3227 20 18.875 19.5523 18.875 19V5C18.875 4.44772 19.3227 4 19.875 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward01SolidRounded);
export default __webpack_public_path__ + "static/media/backward-01-solid-rounded.16d4d096f5314e20a93b90deb37f7dbc.svg";
export { ForwardRef as ReactComponent };